import styled from 'styled-components';

export const QuillContainer = styled.div<{
  isErrored?: boolean;
  popoupOHover?: boolean;
  showActions?: boolean;
  disabled?: boolean;
}>`
  width: 100%;
  position: relative;
  pointer-events: ${({ disabled }: any) => (disabled ? 'none' : 'auto')};
  // &:hover .label-action {
  //   ${({ popoupOHover }) => (popoupOHover ? 'display: block;' : '')}
  // }
  strong {
    font-weight: 600;
  }
  & > div.error {
    padding-left: 2px;
    padding-top: 4px;
    font-size: 12px;
    color: var(--text-danger);
  }

  .editor-action.is-open ~ div.error {
    position: absolute;
    bottom: -8px;
  }

  .quill.is-open .ql-editor {
    padding: 10px 10px 65px 10px;
  }
  .editor-action {
    display: none;
    opacity: 0;
    transition: opacity 300ms linear;
    border-top: 1px solid var(--color-smoke-50);
    margin-left: 2px;
    margin-right: 2px;
    position: relative;
    bottom: 40px;
    height: 10px;
    text-align: right;
  }
  .editor-action.is-open {
    display: block;
    opacity: 1;
  }
  .editor-action.is-open .label-action {
    display: inline-block;
    opacity: 1;
    padding-right: 10px;
    padding-top: 8px;
  }

  .quill:hover {
    border-color: ${({ isErrored }: any) =>
      isErrored ? 'var(--text-danger)' : '#92a2b1'};
    transition: 0.2s linear;
  }

  .quill.is-open,
  .quill:focus-within {
    border-color: ${({ isErrored }: any) =>
      isErrored ? 'var(--text-danger)' : '#2c5cc5'};
    transition: 0.2s linear;
  }
  .char-count {
    position: absolute;
    z-index: 1;
    opacity: 0;
    font-size: 12px;
    color: #000;
    right: 15px;
    bottom: 55px;
    line-height: 18px;
    &.is-open {
      opacity: 1;
      transition: opacity 0.8s linear;
    }
  }

  .quill {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
    border-width: 2px;
    border-style: solid;
    border-color: ${({ isErrored }: any) =>
      isErrored ? 'var(--text-danger)' : '#fff'};
    border-radius: 4px;
  }
  .ql-tooltip {
    z-index: 2;
    border: 1px solid #efefef;
    box-shadow: 0px 0px 5px #efefef;
    border-radius: 4px;
    padding: 8px 12px;
    input {
      border-radius: inherit;
    }
  }

  .is-open .ql-toolbar {
    ${({ showActions }) => (showActions ? 'visibility: visible;' : '')}
  }

  .ql-toolbar {
    border: none !important;
    width: calc(100% - 148px);
    z-index: 1;
    position: relative;
    display: ${({ showActions }) => (showActions ? 'block' : 'none')};
    visibility: ${({ showActions }) => (showActions ? 'hidden' : 'visible')};
  }
  .ql-container {
    border: none !important;
  }

  .ql-editor::before {
    line-height: 24px;
    font-style: normal !important;
    font-size: 18px !important;
    color: #183247 !important;
    opacity: 0.4 !important;
    font-weight: 500;
  }
  .ql-container .ql-editor p {
    color: #000;
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
  }
  .ql-editor {
    padding: 10px 10px 10px 10px;
    min-height: 34px !important;
    max-height: 550px !important;
    overflow: auto;
    transition: padding 200ms linear;

    ul {
      padding-left: 10px;
      color: #000;
      font-size: 16px;
      line-height: 1.5;
      margin: 0;
      li:not(.ql-direction-rtl) {
        padding-left: 0;
      }
    }
  }
  .placeholder-tag {
    font-weight: 500;
    color: var(--color-azure-800);
  }
`;

export const PopupLink = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #0851dd;
  :hover {
    cursor: pointer;
    text-decoration-line: underline;
  }
`;
